// Auto-registered Stimulus controllers.

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import OrderFormController from "./order_form_controller"
application.register("order-form", OrderFormController)

import OtpFormController from "./otp_form_controller"
application.register("otp-form", OtpFormController)

import ActivationCodeController from "./activation_code_controller"
application.register("activation-code", ActivationCodeController)
